import { render, staticRenderFns } from "./form-confirm.vue?vue&type=template&id=e936d34c&scoped=true"
import script from "./form-confirm.vue?vue&type=script&lang=js"
export * from "./form-confirm.vue?vue&type=script&lang=js"
import style0 from "./form-confirm.vue?vue&type=style&index=0&id=e936d34c&prod&lang=css"
import style1 from "./form-confirm.vue?vue&type=style&index=1&id=e936d34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e936d34c",
  null
  
)

export default component.exports